import React from 'react';
import { SVGIcons } from 'src/common-ui/icons.enum';
import { SVGIcon } from 'src/common-ui/svg-icon/svg-icon.component';
export const SplashscreenComponent = () => {
    return (React.createElement("div", { className: "splashscreen" },
        React.createElement("div", { className: "overlay" },
            React.createElement("div", { className: "top" }),
            React.createElement("div", { className: "bottom" })),
        React.createElement(SVGIcon, { className: "logo", icon: SVGIcons.KEYCHAIN_LOGO_SPLASHSCREEN }),
        React.createElement("div", { className: "loading-animation-container" },
            React.createElement("div", { className: "ball first" }),
            React.createElement("div", { className: "ball second" }),
            React.createElement("div", { className: "ball third" }))));
};
